import IntlMessages from "../../../util/IntlMessages";
import { Icon_Empty_Default, Icon_Empty_Simple } from "../Icons/icons";
import "./Empty.less";

interface EmptyProps {
   className?: string;
   image?: React.ReactNode;
   description?: string;
}

/**
 * Props for the `Empty` component.
 *
 * @interface EmptyProps
 * @property {string} [className] - Optional CSS class names to style the component.
 * @property {React.ReactNode} [image] - Optional image to display in the empty state.
 * @property {string} [description] - Optional description text for the empty state.
 */
export const Empty: React.FC<EmptyProps> & {
   IMAGE_SIMPLE: React.ReactNode;
   IMAGE_DEFAULT: React.ReactNode;
} = ({ className = "", description, image }) => {
   return (
      <div className={`${className} bp2-empty`} data-testid={"bp2-empty"}>
         <div className="bp2-empty__image">{image ? image : Empty.IMAGE_SIMPLE}</div>
         <p className="bp2-empty__text">
            {description ? description : <IntlMessages id="empty.noData" />}
         </p>
      </div>
   );
};
Empty.IMAGE_SIMPLE = <Icon_Empty_Simple />;
Empty.IMAGE_DEFAULT = <Icon_Empty_Default />;
